import type React from "react";

const AktBedriftLogo: React.FC = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		version="1.1"
		x="0px"
		y="0px"
		viewBox="0 0 567.6 107.8"
		xmlSpace="preserve"
		width="150px"
		data-test-id="akt-logo"
	>
		<title>AKTBedrift logo</title>
		<g>
			<circle fill="#00A070" cx="53.9" cy="53.9" r="53.9" />
			<path
				fill="#FFFFFF"
				d="M152,43.1h4.3l13.1,30.1h-5.1l-3.4-7.9h-13.5l-3.4,7.9h-5.1L152,43.1z M159,60.9l-4.8-11.2l-4.9,11.2H159z"
			/>
			<path
				fill="#FFFFFF"
				d="M175.5,74.9c0.9,2.5,2.9,3.6,5.9,3.6c3.2,0,5.8-2.1,5.8-6.2v-2.5c-1.6,2.1-4.1,3.4-6.8,3.3   c-5.7,0-10.2-4.8-10.2-10.8s4.4-10.7,10.2-10.7c2.7-0.1,5.2,1.2,6.8,3.3V52h4.7v19.9c0,7.4-4.9,10.6-10.6,10.6s-9.8-3.2-10.3-7.6   H175.5z M181.2,55.9c-3.6-0.1-6.6,2.7-6.7,6.3c-0.1,3.6,2.7,6.6,6.3,6.7s6.6-2.7,6.7-6.3c0-0.1,0-0.2,0-0.2c0.1-3.4-2.6-6.3-6-6.4   C181.5,55.8,181.4,55.8,181.2,55.9L181.2,55.9z"
			/>
			<path
				fill="#FFFFFF"
				d="M206.3,51.6c2.6,0,5.2,1.2,6.8,3.3V41.4h4.7v31.8H213v-2.8c-1.6,2.1-4.1,3.3-6.8,3.3c-5.8,0-10.2-5-10.2-11   S200.5,51.6,206.3,51.6z M207.1,55.8c-3.8,0-6.3,3-6.3,6.8c0,3.8,2.5,6.8,6.3,6.8s6.3-3,6.3-6.8S210.9,55.8,207.1,55.8L207.1,55.8z   "
			/>
			<path
				fill="#FFFFFF"
				d="M232.9,73.6c-6.3,0-10.9-4.7-10.9-11s4.4-11,10.9-11s11,5,10.6,12.2h-16.9c0.1,3.3,2.9,5.9,6.2,5.8   c0.1,0,0.1,0,0.2,0c2.2,0.2,4.3-1,5.3-3h4.9C242.1,70.5,238.3,73.6,232.9,73.6z M226.8,60.5h11.7c-0.7-3.4-3.1-5-5.7-5   C229.8,55.3,227.2,57.5,226.8,60.5L226.8,60.5z"
			/>
			<path
				fill="#FFFFFF"
				d="M247.7,52h4.7v3.8c0.8-2.4,3.1-4,5.6-4c0.6,0,1.2,0.1,1.8,0.2v4.8c-0.8-0.3-1.5-0.4-2.3-0.4   c-2.7,0-5.1,2.2-5.1,6.5v10.3h-4.7V52z"
			/>
			<path
				fill="#FFFFFF"
				d="M273.7,41.4h4.7v18.7l8.1-8h5.9l-9.5,9.5l11.6,11.7h-6L278.4,63v10.2h-4.7L273.7,41.4L273.7,41.4z"
			/>
			<path
				fill="#FFFFFF"
				d="M304.7,73.6c-6.1-0.1-11-5-10.9-11.1s5-11,11.1-10.9c6,0.1,10.9,5,10.9,11s-4.8,11-10.9,11   C304.9,73.6,304.8,73.6,304.7,73.6z M304.7,69.3c3.7,0,6.4-2.9,6.4-6.7c0.1-3.5-2.6-6.5-6.1-6.6s-6.5,2.6-6.6,6.1   c0,0.2,0,0.3,0,0.5c-0.2,3.5,2.5,6.5,6.1,6.7C304.5,69.3,304.6,69.3,304.7,69.3L304.7,69.3z"
			/>
			<path fill="#FFFFFF" d="M320,41.4h4.7v31.8H320V41.4z" />
			<path fill="#FFFFFF" d="M330.2,41.4h4.7v31.8h-4.7V41.4z" />
			<path
				fill="#FFFFFF"
				d="M349.9,73.6c-6.3,0-10.8-4.7-10.8-11s4.4-11,10.9-11s11,5,10.6,12.2h-16.9c0.1,3.3,2.9,5.9,6.2,5.8   c0.1,0,0.1,0,0.2,0c2.2,0.2,4.3-1,5.3-3h4.9C359.1,70.5,355.3,73.6,349.9,73.6z M343.8,60.5h11.7c-0.7-3.4-3.1-5-5.7-5   C346.8,55.3,344.2,57.5,343.8,60.5z"
			/>
			<path
				fill="#FFFFFF"
				d="M364.7,41.4h4.7v18.7l8.1-8h5.9l-9.5,9.5l11.6,11.7h-6L369.4,63v10.2h-4.7L364.7,41.4L364.7,41.4z"
			/>
			<path
				fill="#FFFFFF"
				d="M397.3,73.4c-4.1,0-7.2-2.2-7.2-7V56.2h-4.4V52h4.4v-5.9h4.7V52h6.1v4.2h-6.1v9.4c0,2.6,1.1,3.6,3.6,3.6   c0.9,0,1.7-0.1,2.5-0.4V73C399.6,73.3,398.4,73.4,397.3,73.4z"
			/>
			<path
				fill="#FFFFFF"
				d="M406.5,47.4c-1.7,0.1-3.2-1.2-3.3-2.9s1.2-3.2,2.9-3.3c0.1,0,0.2,0,0.4,0c1.7,0.1,3,1.6,2.9,3.3   C409.4,46,408.1,47.3,406.5,47.4z M404.2,52h4.7v21.2h-4.7V52z"
			/>
			<path
				fill="#FFFFFF"
				d="M411.7,52h5.2l6.4,14.8l6.5-14.8h5.2l-9.6,21.2h-4.1L411.7,52z"
			/>
			<path
				fill="#FFFFFF"
				d="M448.3,73.4c-4.1,0-7.2-2.2-7.2-7V56.2h-4.4V52h4.4v-5.9h4.7V52h6.1v4.2h-6.1v9.4c0,2.6,1.1,3.6,3.6,3.6   c0.9,0,1.7-0.1,2.5-0.4V73C450.6,73.3,449.4,73.4,448.3,73.4z"
			/>
			<path
				fill="#FFFFFF"
				d="M455.6,52h4.7v3.8c0.8-2.4,3.1-4,5.6-4c0.6,0,1.2,0.1,1.8,0.2v4.8c-0.8-0.3-1.5-0.4-2.3-0.4   c-2.7,0-5.1,2.2-5.1,6.5v10.3h-4.7V52z"
			/>
			<path
				fill="#FFFFFF"
				d="M479.7,51.6c2.6,0,5.2,1.2,6.8,3.3V52h4.7v21.2h-4.7v-2.8c-1.6,2.1-4.1,3.3-6.8,3.3c-5.8,0-10.2-5-10.2-11   S473.9,51.6,479.7,51.6z M480.5,55.8c-3.8,0-6.3,3-6.3,6.8c0,3.8,2.5,6.8,6.3,6.8s6.3-3,6.3-6.8S484.3,55.8,480.5,55.8z"
			/>
			<path
				fill="#FFFFFF"
				d="M498.8,56.2h-4.4V52h4.4v-3.6c0-4.8,3.2-7.3,7.2-7.3c1.2,0,2.3,0.2,3.5,0.5v4.2c-0.8-0.3-1.6-0.4-2.5-0.4   c-2.4,0-3.6,1-3.6,3.6v3h6.1v4.2h-6.1v17h-4.7v-17H498.8z M515.6,47.4c-1.7,0.1-3.2-1.2-3.3-2.9s1.2-3.2,2.9-3.3c0.1,0,0.2,0,0.4,0   c1.7,0.1,3,1.6,2.9,3.3C518.5,46,517.2,47.3,515.6,47.4z M513.3,52h4.7v21.2h-4.7V52z"
			/>
			<path
				fill="#FFFFFF"
				d="M523.6,41.4h4.7v18.7l8.1-8h5.9l-9.5,9.5l11.5,11.7h-6l-10-10.3v10.2h-4.7V41.4z"
			/>
			<path
				fill="#FFFFFF"
				d="M546.8,41.4h4.7v18.7l8.1-8h5.9l-9.5,9.5l11.6,11.7h-6L551.5,63v10.2h-4.7V41.4z"
			/>
			<g>
				<polygon
					fill="#FFFFFF"
					points="67.7,47.7 76.5,47.7 62.7,16.4 58.3,26.3   "
				/>
				<polygon
					fill="#FFFFFF"
					points="83.6,63.8 80.1,55.8 71.3,55.8 62.5,55.8 45.2,55.8 41.7,63.8 66.1,63.8 74.8,63.8 83.4,83.2     92.2,83.2   "
				/>
				<polygon
					fill="#FFFFFF"
					points="58.2,6.6 49.5,6.6 49.5,6.5 49.4,6.6 15.6,83.2 24.3,83.2   "
				/>
				<polygon
					fill="#FFFFFF"
					points="58.3,6.6 58.3,6.6 58.3,6.5 58.2,6.6   "
				/>
			</g>
			<g>
				<polygon
					fill="#FFFFFF"
					points="67.7,47.7 76.5,47.7 62.7,16.4 58.3,26.3   "
				/>
				<polygon
					fill="#FFFFFF"
					points="83.6,63.8 80.1,55.8 71.3,55.8 62.5,55.8 45.2,55.8 41.7,63.8 66.1,63.8 74.8,63.8 83.4,83.2     92.2,83.2   "
				/>
				<polygon
					fill="#FFFFFF"
					points="58.2,6.6 49.5,6.6 49.5,6.5 49.4,6.6 15.6,83.2 24.3,83.2   "
				/>
				<polygon
					fill="#FFFFFF"
					points="58.3,6.6 58.3,6.6 58.3,6.5 58.2,6.6   "
				/>
			</g>
		</g>
		<g />
	</svg>
);

export default AktBedriftLogo;
